import ServiceGraphQL from 'src/service/gql-service';
import { getCompanySettlements } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const GetCompanySettlements = (companyId, from) => {
  const params = {
    query: getCompanySettlements.QUERY,
    variables: {
      companyId,
      from
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res.data.companiesOne;
    })
    .catch((err) => {
      throw err;
    });
};
